module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=RW - Rwanda.87d3b69a.svg";